<ng-container *ngIf="vm$ | async as vm">
    <ng-container *ngIf="!vm.isPickLoading" [ngSwitch]="vm.pick.oddsState">
        <ng-container *ngSwitchCase="oddsStateType.Open">
            <ng-container *ngIf="teasedValue; else oddsValue">
                <div class="betslip-pick-odds__value">
                    <span class="betslip-pick-odds__new-points">{{ teasedValue }}</span>
                </div>
            </ng-container>
            <ng-template #oddsValue>
                <ng-container *ngIf="!vm.isPriceBoosted; else priceBoost">
                    <span class="odds-bog-container" *ngIf="vm.bogVisible">
                        <ms-help-box-badge class="best-odds" [boxType]="'bestoddsguarantee'" />
                    </span>
                    <span class="betslip-pick-odds__original-value" *ngIf="vm.boostedPrice" [@oldOddsAnimation]="vm.currentPrice">{{
                        vm.currentPrice
                    }}</span>
                    <div
                        class="betslip-pick-odds__value"
                        [ngClass]="{
                            'betslip-pick-odds__boosted': vm.boostedPrice,
                            'betslip-pick-odds__value--up': vm.oddsAreUp,
                            'betslip-pick-odds__value--down': vm.oddsAreDown,
                        }"
                        [@newOddsAnimation]="vm.boostedPrice">
                        {{ vm.boostedPrice ?? vm.currentPrice }}
                    </div>
                </ng-container>
            </ng-template>
            <ng-template #priceBoost>
                <span class="was-price was-price-betslip"> {{ vm.currentPrice }}</span>
                <ms-priceboost-count-signpost *ngIf="vm.isPriceBoosted && vm.priceBoostOdds" [count]="vm.priceBoostOdds" [isLargeSignPost]="true" />
            </ng-template>
        </ng-container>
        <div
            class="betslip-pick-odds__value--locked"
            *ngSwitchCase="oddsStateType.Locked"
            [ngClass]="isEpcotEnabled ? 'theme-lock' : 'theme-locked-i'"></div>
        <div class="betslip-pick-odds__value--closed" *ngSwitchCase="oddsStateType.Closed">{{ messages.closed }}</div>
    </ng-container>
</ng-container>
